import { render, staticRenderFns } from "./set-new-password.vue?vue&type=template&id=4b6b2989&scoped=true"
import script from "./set-new-password.vue?vue&type=script&setup=true&lang=js"
export * from "./set-new-password.vue?vue&type=script&setup=true&lang=js"
import style0 from "./set-new-password.vue?vue&type=style&index=0&id=4b6b2989&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b2989",
  null
  
)

export default component.exports